import { Button, buttonVariants } from '#/components/ui/button';
import { VariantProps } from 'class-variance-authority';
import { IconType, Icons } from '../icons';

interface IconButtonProps extends VariantProps<typeof buttonVariants> {
  text: string;
  onClick?: () => Promise<void> | void;
  disabled?: boolean;
  Icon: IconType;
}
export default function IconButton({
  text,
  onClick,
  disabled,
  Icon,
  ...props
}: IconButtonProps) {
  return (
    <Button disabled={disabled} onClick={onClick} {...props}>
      {disabled ? (
        <Icons.spinner className="btn-spinner-with-text" />
      ) : (
        <Icon className="mr-2 h-4 w-4" />
      )}
      {text}
    </Button>
  );
}
